export const ADD_QUERIES = "ADD_QUERIES";
export const RESET_QUERIES = "RESET_QUERIES";
export const SET_CASE_ID = "SET_CASE_ID";
export const SET_QUERY_DOCS = "SET_QUERY_DOCS";




export const addQueryDocs = (data) => {
  return {
    type: SET_QUERY_DOCS,
    data,
  };
};
export const addQueries = (data) => {
  return {
    type: ADD_QUERIES,
    data,
  };
};
export const setCaseId = (data) => {
  return {
    type: SET_CASE_ID,
    data,
  };
};

export const resetQueries = () => {
  return {
    type: RESET_QUERIES,
  };
};


